import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { GLOBAL_CART_FEATURE_NAME } from '~shared/modules/shopping-cart-global/store/feature-name';
import * as fromGlobalCart from './store';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    StoreModule.forFeature(GLOBAL_CART_FEATURE_NAME, fromGlobalCart.reducers),
    EffectsModule.forFeature([fromGlobalCart.CartEffects])
  ],
  exports: []
})
export class ShoppingCartGlobalModule {
}
